import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { useFunction, ScreenSizer } from "@project-rouge/rg-three";
import { Line, Billboard, Plane } from "@react-three/drei";
import { memo, useMemo, useState } from "react";
import { Vector3, MathUtils, BackSide } from "three";
import { Shape } from "./index47.js";
import { getBuildingCenter } from "./index221.js";
import { useCursor } from "./index222.js";
import { getWingPoly } from "./index175.js";
const SelectWingButton = memo(({ building, bone, onClick, topOffset, readonly }) => {
  const position = useMemo(() => {
    const pos = getBuildingCenter(building, bone);
    pos[1] *= 2;
    pos[1] += topOffset;
    return pos;
  }, [building, bone, topOffset]);
  const wingPoly = useMemo(() => getWingPoly({ building, bone, level: bone.floors - 1, skipCornerCores: true }), [building, bone]);
  const wingPolyWithCornerCores = useMemo(() => getWingPoly({ building, bone, level: bone.floors - 1 }), [building, bone]);
  const [hover, setHover] = useState(false);
  useCursor(hover);
  const onPointerOver = useFunction((e) => {
    if (!hasPriority(e)) {
      if (hover)
        setHover(false);
      return;
    }
    if (!hover)
      setHover(true);
  });
  const onPointerOut = useFunction(() => {
    if (hover)
      setHover(false);
  });
  const _onClick = useFunction((e) => {
    if (!hasPriority(e))
      return;
    e.stopPropagation();
    onClick(bone);
  });
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    !readonly && /* @__PURE__ */ jsx(Icon, { position, hover }),
    /* @__PURE__ */ jsx(
      Top,
      {
        position,
        wingPoly,
        wingPolyWithCornerCores,
        onClick: _onClick,
        onPointerMove: onPointerOver,
        onPointerOut,
        readonly
      }
    )
  ] });
});
SelectWingButton.displayName = "SelectWingButton";
const vector3 = new Vector3();
function hasPriority(e) {
  const intersections = e.intersections.filter((i) => i.object.userData.wingCenter);
  let closestObj = intersections[0].object;
  vector3.fromArray(closestObj.userData.wingCenter);
  let closestDistSq = vector3.distanceToSquared(e.point);
  for (let i = 1; i < intersections.length; i++) {
    const obj = intersections[i].object;
    vector3.fromArray(obj.userData.wingCenter);
    const distSq = vector3.distanceToSquared(e.point);
    if (distSq >= closestDistSq)
      continue;
    closestObj = obj;
    closestDistSq = distSq;
  }
  return closestObj === e.object;
}
const Top = ({
  position,
  wingPoly,
  wingPolyWithCornerCores,
  onClick,
  onPointerMove,
  onPointerOut,
  readonly
}) => /* @__PURE__ */ jsxs(
  "object3D",
  {
    position: [0, position[1], 0],
    rotation: [90 * MathUtils.DEG2RAD, 0, 0],
    children: [
      /* @__PURE__ */ jsx(
        Shape,
        {
          points: wingPolyWithCornerCores,
          "material-side": BackSide,
          "material-depthTest": false,
          "material-depthWrite": false,
          visible: false,
          onClick: !readonly ? onClick : void 0,
          onPointerMove: !readonly ? onPointerMove : void 0,
          onPointerOut: !readonly ? onPointerOut : void 0,
          userData: { wingCenter: position }
        }
      ),
      /* @__PURE__ */ jsx(
        Shape,
        {
          points: wingPoly,
          "material-side": BackSide,
          "material-transparent": true,
          "material-opacity": 0.5
        }
      ),
      /* @__PURE__ */ jsx(
        Line,
        {
          points: wingPoly,
          transparent: true,
          color: "#3B3B5F"
        }
      )
    ]
  }
);
const Icon = ({
  position,
  hover
}) => {
  const size = !hover ? 8 : 10;
  const halfSize = size * 0.5;
  const points = useMemo(() => [
    [-halfSize, 0, -halfSize],
    [halfSize, 0, -halfSize],
    [halfSize, 0, halfSize],
    [-halfSize, 0, halfSize],
    [-halfSize, 0, -halfSize]
  ], [size]);
  return /* @__PURE__ */ jsx(ScreenSizer, { position, children: /* @__PURE__ */ jsxs(Billboard, { position: [0, 5, 0], children: [
    /* @__PURE__ */ jsx(
      Plane,
      {
        args: [size, size],
        "material-color": !hover ? "#ffffff" : "#3B3B5F"
      }
    ),
    /* @__PURE__ */ jsx(
      Line,
      {
        points,
        color: !hover ? "#60666C" : "#9E9ED1",
        rotation: [-90 * MathUtils.DEG2RAD, 0, 0]
      }
    )
  ] }) });
};
export {
  SelectWingButton
};
//# sourceMappingURL=index224.js.map
